import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../../../reducers/types";
import {
  setOpenModal,
  setSelectedFlight,
  setSelectedHotel,
} from "../../../../actions/actions";
import { ItinerariesModal } from "./component";
import {
  getAirlinesMap,
  getAirportMap,
  getOpenModal,
  getTripsFilter,
} from "../../../../reducer";
import { getRedeemedEarnOffers } from "../../../../../../modules/travel-wallet/reducer";

const mapStateToProps = (state: IStoreState) => ({
  openModal: getOpenModal(state),
  tripsFilter: getTripsFilter(state),
  airportMap: getAirportMap(state),
  airlineMap: getAirlinesMap(state),
  redeemedEarnOffers: getRedeemedEarnOffers(state),
});

const mapDispatchToProps = {
  setOpenModal,
  setSelectedHotel,
  setSelectedFlight,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ItinerariesModalConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedItinerariesModal = connector(ItinerariesModal);
